<template>
  <div>
    <div style="width:100%;border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">基本信息</div>
    <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
      <tr>
        <td class="tableLabel">售后单号：</td>
        <td>{{specialApplication.billNo}}</td>
        <td class="tableLabel">出厂编号：</td>
        <td>{{specialApplication.factoryNo}}</td>
        <td class="tableLabel">关联单号：</td>
        <td>{{specialApplication.relevanceNo}}</td>
      </tr>
      <tr>
        <td class="tableLabel">特批来源：</td>
        <td>
          <el-select v-model="specialApplication.applyType" disabled placeholder="请选择">
            <el-option
                v-for="item in specialApplicationTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </td>
        <td class="tableLabel">申请人：</td>
        <td>{{specialApplication.creatorName}}</td>
        <td class="tableLabel">申请部门：</td>
        <td>{{specialApplication.applicantDepartment}}</td>
      </tr>
      <tr>
        <td class="tableLabel">物料名称：</td>
        <td>{{specialApplication.materialName}}</td>
        <td class="tableLabel">物料编号：</td>
        <td>{{specialApplication.materialNo}}</td>
        <td class="tableLabel">数量：</td>
        <td>{{specialApplication.quantity}}</td>
      </tr>
      <tr>
        <td class="tableLabel">联系方式：</td>
        <td>{{specialApplication.mobile}}</td>
        <td class="tableLabel">特批原因：</td>
        <td>{{specialApplication.specialReason}}</td>
        <td class="tableLabel">造成影响：</td>
        <td>
          <el-select v-model="specialApplication.defectResult" disabled placeholder="请选择">
            <el-option
                v-for="item in defectResults"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </td>
      </tr>

      <tr>
        <td class="tableLabel">备注：</td>
        <td colspan="5">{{specialApplication.note}}</td>
      </tr>
      <tr>
        <td class="tableLabel">对风险的措施：</td>
        <td colspan="5">{{specialApplication.measures}}</td>
      </tr>
      <tr>
        <td class="tableLabel">选择特批部门：</td>
        <td colspan="5">
          <el-checkbox-group v-model="specialApplication.specialDepartmentList">
            <el-checkbox-button v-for="item in specialDepartmentList" :key="item" :label="item">{{item}}</el-checkbox-button>
          </el-checkbox-group>
        </td>
      </tr>
    </table>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="specialApplication.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";
  export default {
    name:"",
    components:{HandleDetail},
    data() {
      return {
        specialApplicationTypes:constant.toSelect(constant.specialApplicationType),
        defectResults:constant.toSelect(constant.defectResult),
        billId:"",
        billType:"30",
        pkid:"",
        specialDepartmentList: ["技术部", "采购部", "客户质量部", " 供应商质量部", "工厂质量部"],
        specialApplication: {
          pkid: "",
          billNo: "",
          applicantDepartment: "",
          creatorName: loginUtil.getName(),
          applyType: "",
          factorNo: "",
          materialName: "",
          materialNo: "",
          quantity: "",
          specialReason: "",
          measures: "",
          relevanceNo: "",
          defectResults: "",
          isJS: false,
          note: "",
          attachments:[],
          specialDepartmentList:[],
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.pkid = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.pkid = "";
      this.specialApplication={};
    },
    methods:{
      downLoad(row) {
        console.log(row);
        let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      getData() {
        this.$http.get("basic",`specialApplications/${this.billId}`).then((res)=>{
          console.log(res);
          this.specialApplication = res;
        }).catch(()=>{
        });
      },
    },
  };
</script>

<style lang="scss">
  table.ProjectOrderTable {
    font-family: verdana,arial,sans-serif;
    font-size:11px;
    color:#333333;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  table.ProjectOrderTable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    background-color: #f4f7fa;
  }
  table.ProjectOrderTable td {
    padding: 8px;
    border-right: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
  }
  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
</style>
